import '../../utils/customQuillBlot'; // Import custom Quill blots
import React, { Fragment, useEffect, useState, useMemo, useRef } from 'react';
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css'; // Required for styling
import PageHeader from "../../view/pageheader";
import { Tabs } from 'antd';
import ButtonComponent from '../../fields/ButtonComponent';
import { updateReportTemplate, getReportTemplate } from "../../store/reducer/reportsSlice";
import { useDispatch, useSelector } from 'react-redux';
import { use } from "react";
import { toast } from 'react-toastify';
import Loader from '../../fields/loader/Loader';

const ReportTemplateEditor = () => {
  const dispatch = useDispatch();
  const { reportTemplateData, updateData, updateReportSuccess, updateReportError, updateReportLoading } = useSelector(state => state.reports);
  const [thankContent, setthankContent] = useState('');
  const [valuationContent, setvaluationContent] = useState('');

  console.log(thankContent, "thankContent==");

  const thankQuillRef = useRef();
  const valuationQuillRef = useRef();

  const insertDivider = () => {
    const quill = thankQuillRef.current?.getEditor();
    if (quill) {
      const range = quill.getSelection();
      if (range) {
        quill.insertEmbed(range.index, 'divider', true);
        quill.setSelection(range.index + 1);
      }
    }
  };

  const insertPageBreak = () => {
    const quill = thankQuillRef.current?.getEditor();
    if (quill) {
      const range = quill.getSelection();
      if (range) {
        quill.insertEmbed(range.index, 'pageBreak', true);
        quill.setSelection(range.index + 1);
      }
    }
  };

  const insertValuationDivider = () => {
    const quill = valuationQuillRef.current?.getEditor();
    if (quill) {
      const range = quill.getSelection();
      if (range) {
        quill.insertEmbed(range.index, 'divider', true);
        quill.setSelection(range.index + 1);
      }
    }
  };

  const insertValuationPageBreak = () => {
    const quill = valuationQuillRef.current?.getEditor();
    if (quill) {
      const range = quill.getSelection();
      if (range) {
        quill.insertEmbed(range.index, 'pageBreak', true);
        quill.setSelection(range.index + 1);
      }
    }
  };

  const handleThankSubmit = () => {
    let postData = {
      id: 2,
      html_content: thankContent,
    }
    dispatch(updateReportTemplate({
      postData
    }));
  };

  const handleValuationSubmit = () => {
    let postData = {
      id: 3,
      html_content: valuationContent,
    }
    dispatch(updateReportTemplate({
      postData
    }));
  };

  useEffect(() => {
    dispatch(getReportTemplate({}));
  }, []);

  useEffect(() => {
    if (reportTemplateData && reportTemplateData.length > 0) {

      const thankTemplate = reportTemplateData.find(item => { return item.id === 2 });
      const valuationTemplate = reportTemplateData.find(item => { return item.id === 3 });

      if (thankTemplate) {
        setthankContent(thankTemplate.html_content || '');
      }
      if (valuationTemplate) {
        setvaluationContent(valuationTemplate.html_content || '');
      }
    }
  }, [reportTemplateData]);

  useEffect(() => {
    toast.dismiss();
    if (updateReportSuccess) {
      toast.success('Template updated successfully');
      setthankContent('');
      setvaluationContent('');
      dispatch(getReportTemplate({}));
    }
    if (updateReportError) {
      toast.error(updateReportError);
      dispatch(getReportTemplate({}));
    }
  }, [updateReportSuccess, updateReportError]);

  const handleImageUpload = () => {
    console.log('function called');

    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();
    console.log('input', input);

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;
      console.log(file, "file==");

      const imageUrl = await uploadImageToServer(file);

      const quill = thankQuillRef.current.getEditor();
      let range = quill.getSelection();

      // If no selection, insert at the end
      if (!range) {
        range = {
          index: quill.getLength(),
          length: 0
        };
      }

      quill.insertEmbed(range.index, 'image', imageUrl);
      quill.setSelection(range.index + 1);

      setTimeout(() => {
        const imgs = quill.root.querySelectorAll(`img[src="${imageUrl}"]`);
        imgs.forEach(img => {
          img.style.maxWidth = '200px';
          img.style.height = 'auto';
          img.style.borderRadius = '6px';
        });
      }, 100);
    };
  };

  const uploadImageToServer = async (file) => {
    console.log('uploadImageToServer called with file:', file);

    const formData = new FormData();
    formData.append('file', file);

    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    // const res = await axios.post('/api/upload', formData); // your backend
    // return res.data.imageUrl; // return the URL
  };

  const handleImageUploadBase64 = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = () => {
      const file = input.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        const quill = thankQuillRef.current.getEditor();
        const range = quill.getSelection(true);
        const base64 = reader.result;

        // ✅ Use insertEmbed to use your CustomImageBlot
        quill.insertEmbed(range.index, 'image', base64);
        quill.setSelection(range.index + 1);
      };

      reader.readAsDataURL(file);
    };
  };

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }, { font: [] }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['link', 'image'],
        ['clean']
      ],
      handlers: {
        // image: handleImageUpload
        image: handleImageUploadBase64
      }

    },
    clipboard: {
      matchVisual: false
    }
  }), []);

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'color', 'background',
    'list', 'bullet', 'indent',
    'align',
    'link', 'image',
    'divider', // Include the custom divider format
    'pageBreak' // Include the custom page break format
  ];

  // const OnthankContent = (value) => {
  //   console.log(value, "value==");

  //   setthankContent(value);
  // };

  const items = [
    {
      key: '1',
      label: 'Thank You Content Template',
      children: <div style={{ padding: '20px' }}>
        <ReactQuill ref={thankQuillRef}
          theme="snow" modules={modules} formats={formats} value={thankContent} onChange={setthankContent} />
        <div className='text-left mt-3'>
          <ButtonComponent style={{ backgroundColor: 'grey', color: 'white' }} onClick={insertDivider} buttonName={'Insert Divider Line'} />&nbsp;
          <ButtonComponent style={{ backgroundColor: 'grey', color: 'white' }} onClick={insertPageBreak} buttonName={'Insert Page Break'} />&nbsp;
        </div>
        <div className='text-center mt-3'>
          <ButtonComponent style={{ backgroundColor: '#f7931e', color: 'white' }} onClick={handleThankSubmit} buttonName={'Save Template'} />&nbsp;
        </div>
      </div>
    },
    {
      key: '2',
      label: 'Valuation Methodology Template',
      children: <div style={{ padding: '20px' }}>
        <ReactQuill ref={valuationQuillRef} theme="snow" modules={modules} formats={formats} value={valuationContent} onChange={setvaluationContent} />
        <div className='text-left mt-3'>
          <ButtonComponent style={{ backgroundColor: 'grey', color: 'white' }} onClick={insertValuationDivider} buttonName={'Insert Divider Line'} />&nbsp;
          <ButtonComponent style={{ backgroundColor: 'grey', color: 'white' }} onClick={insertValuationPageBreak} buttonName={'Insert Page Break'} />&nbsp;
        </div>
        <div className='text-center mt-3'>
          <ButtonComponent style={{ backgroundColor: '#f7931e', color: 'white' }} onClick={handleValuationSubmit} buttonName={'Save Template'} />&nbsp;
        </div>
      </div>
    },
  ];

  return (
    <>
      <PageHeader
        HeaderText={"Home Inventory Report Template"}
        Breadcrumb={[{ name: "Report Template" }]}
      />
      <Loader loading={updateReportLoading} />
      <Tabs defaultActiveKey="1" items={items} />
    </>
  );
};

export default ReportTemplateEditor;
